import storeutilis from '@/helpers/storeutilis';

export default {
	presentation: state => {
        return state.presentation;
    },
	charts: state => {
        return state.charts;
    },
    chartemplates_loading: state => {
        return state.chartemplates_loading;
    },




    persistedtime_chartemplates: state => {
    	return state.persistedtime_chartemplates;
    },

    chartemplates: state => {
    	// if(!state.persistedtime_chartemplates || !isCacheValid(state.persistedtime_chartemplates)) return false;

        return state.chartemplates;
    },

    addchart: state => {
        return state.addchart;
    },

    ordertCharts: state => {
    	return storeutilis.orderCharts(state.charts);
  	},

  	getBackgroundImageByChartId: (state, getters) => (id) => {
    	const chart = getters.getChartById(id);

    	if(chart.image) {
			return chart.image;
		}

		if(chart.fields && chart.fields['background-image']){
			return chart.fields['background-image'].value;
		}

		return false;
  	},

  	getChartField: (state, getters) => (chartid, fieldname, getWithParent) => {
  		const chart = getters.getChartById(chartid, getWithParent);

  		if(chart.fields && chart.fields[fieldname]){
  			return chart.fields[fieldname];
  		}

  		if(chart.parent && chart.parent.fields && chart.parent.fields[fieldname]){
  			return chart.parent.fields[fieldname];
  		}

  		return false;
  	},

  	getChartFields: (state, getters) => (chartid, getWithParent) => {
  		const chart = getters.getChartById(chartid, getWithParent);
  		let fields = chart.fields;

  		if(getWithParent && chart.parent && chart.parent.fields){
  			fields = Object.assign({}, chart.parent.fields, chart.fields);
  		}

  		return fields || false;
  	},

    getChartById: state => (id, getWithParent) => {
    	if(!state.charts) return false;

    	if(state.charts[id]){
    		return state.charts[id];
    	}

    	return storeutilis.findChart(state.charts, id, getWithParent);
  	},
  	getUsereditFieldById: state => (name) => {
    	if(!state.edituser) return false;
    	if(!state.edituser.fields) return false;
    	return storeutilis.getUsereditFieldById(state.edituser.fields, name);
  	},



    active_presentation: state => {
        return (state.active_presentation == 0 ? false : state.active_presentation);
    },

    active_field: state => {
        return (state.active_field == 0 ? false : state.active_field);
    },
    active_field_el: state => {
        return state.active_field_el;
    },

    chartcomponents: state => {
    	return state.editor.chartcomponents;
    },
    newchartcounter: state => {
        return state.newchartcounter;
    },
}



// WEBPACK FOOTER //
// ./src/store/preseditor/getters.js